import { getHumanReadableDate } from "../../../dialpad/service/chat.service";
import { v4 as uuidv4 } from 'uuid';

function updateObjectByPath(obj, path, value) {
  const keys = path.split('.');
  let currentObj = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!currentObj.hasOwnProperty(key) || typeof currentObj[key] !== 'object') {
      currentObj[key] = {};
    }
    currentObj = currentObj[key];
  }

  currentObj[keys[keys.length - 1]] = value;
}
function getObjectValue(obj, path) {
  const keys = path.split('.');
  let currentObj = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!currentObj.hasOwnProperty(key) || typeof currentObj[key] !== 'object') {
      currentObj[key] = {};
    }
    currentObj = currentObj[key];
  }

  return currentObj[keys[keys.length - 1]];
}

const removeElementById = (arr, key, idToRemove) => {
  return arr.filter((obj) => obj[key] !== idToRemove);
}
const getTime = () => {
  // const today = new Date();
  // const time = today.getHours() + ":" + today.getMinutes();
  // return time;
  const date =  new Date().toISOString();
  return getHumanReadableDate(date)
}

const getUUID = () => {
  return uuidv4();
}
const removeSpecialCharactersAndGetLast10 = (input) => {
  try {
    // Convert input to string if it's a number
    let inputStr = input.toString();
  
    // Remove special characters using regular expression (keep only alphanumeric characters)
    let cleanedStr = inputStr.replace(/[^a-zA-Z0-9]/g, '');
  
    // Get the last 10 characters
    let last10Chars = cleanedStr.slice(-10);
  
    return last10Chars;
  } catch (error) {
   return ""; 
  }
}
export {
  updateObjectByPath,
  removeElementById,
  getObjectValue,
  getTime,
  getUUID,
  removeSpecialCharactersAndGetLast10,
}


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/utils.js